import type { FC } from 'react';

import { useCreateAuthenticatedSession, useTranslations, useOpenChatQueryParamOnMount } from '../../hooks';
import { Icon } from '../Icon';
import { WEB_MESSENGER_BUTTON } from './constants';
import { ButtonComponent, Label } from './styles';
import { useButton } from './useButton';

/**
 * Describes timeout after which chat is opened
 */
const OPEN_CHAT_TIMEOUT = 5 * 1000; // ms

export const Button: FC = () => {
  const { translations } = useTranslations();
  const { isChatOpened, onClick } = useButton();

  useCreateAuthenticatedSession();
  useOpenChatQueryParamOnMount(onClick, OPEN_CHAT_TIMEOUT);

  return (
    <ButtonComponent
      data-testid={WEB_MESSENGER_BUTTON}
      isChatOpened={isChatOpened}
      onClick={onClick}
    >
      <Icon isChatOpened={isChatOpened} />
      <Label>{isChatOpened ? translations.closeChat : translations.chatWithUs}</Label>
    </ButtonComponent>
  );
};
